
import { defineComponent } from 'vue';
import IconComponent from '@/components/ui/IconComponent.vue';
import { useToast } from '@/composables/useToast';

export default defineComponent({
    components: {
        IconComponent,
    },
    setup() {
        const { toasts, toastSingle, removeToast, removeToastSingle } = useToast();
        return {
            toasts,
            toastSingle,
            removeToast,
            removeToastSingle,
        };
    },
});
